import { MaskedLines, FadeIn } from "./motion";

export const PageHero = ({ kicker, lines, sub, testid }) => (
  <section className="relative overflow-hidden bg-slate-50 border-b border-slate-100" data-testid={testid}>
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(45% 60% at 85% 10%, rgba(37,84,235,0.07), transparent 70%)" }}
    />
    <div className="relative container-x py-16 sm:py-24 max-w-7xl">
      <FadeIn>
        <span className="kicker">{kicker}</span>
      </FadeIn>
      <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-ink leading-[1.05] max-w-4xl">
        <MaskedLines lines={lines} />
      </h1>
      {sub && (
        <FadeIn delay={0.5}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">{sub}</p>
        </FadeIn>
      )}
    </div>
  </section>
);
